module.exports = __webpack_public_path__ + "static/media/notebook-orange.60792a8b.svg";